import { Component, OnInit } from '@angular/core';
import { NewsletterService } from './../../services/newsletter.service';
import { AppConfig } from './../../config/app-config';
import { FileSection, FileType, FileData } from './../../models/fileData';
import { ActivatedRoute } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-newsletters',
  templateUrl: './newsletters.component.html'
})
export class NewslettersComponent implements OnInit {

  newsletterId: number;

  constructor(private route: ActivatedRoute, private newsletterService: NewsletterService, private appConfig: AppConfig) {
    this.route.queryParams.subscribe((params) => {

      if (params["newsletterId"]) {
        this.newsletterId = params["newsletterId"];
      }
      else
        this.newsletterId = 0;
    })
  }

  ngOnInit() {
    //this.newsletterId);
    if (this.newsletterId > 0)
      this.downloadFile(this.newsletterId);
  }

  AllNewsletter: any[] = [];
  NewsletterCategories$: any[] = [];
  NewsletterList$: any[] = [];
  LatestNewsletter$: any[] = [];
  Years$: any[] = [];

  selectedCategory$: number = 0;
  selectedYear$: number = 0;

  collectionSize: number = 0;



  getNewsletterCategoriesList() {
    this.newsletterService.getNewsletterCategoriesList().subscribe((response) => {
      this.NewsletterCategories$ = response as any[];
    }, (error) => {
      console.log(error);
    });
  }

  getNewsletterList() {
    this.newsletterService.getNewsletterList().subscribe((response) => {

      this.AllNewsletter = response as any[];
      this.NewsletterList$ = this.AllNewsletter;

      this.collectionSize = this.NewsletterList$.length;

      this.getLatestNewsletter();
    }, (error) => {
      console.log(error);
    });
    return null;
  }

  getLatestNewsletter() {
    this.LatestNewsletter$ = this.AllNewsletter.sort(x => x.dateAdded)[0];
  }

  getYearList() {
    let currYear = new Date().getFullYear();
    let startYear: number = currYear - 5;
    let endYear: number = currYear;

    for (let i = startYear; i <= endYear; i++) {
      this.Years$.push(i);
    }
  }

  ngAfterContentInit() {
    this.getNewsletterCategoriesList();
    this.getNewsletterList();
    this.getYearList();
  }

  applyFilters() {

    this.NewsletterList$ = this.AllNewsletter;

    var result = [];

    if (this.selectedCategory$ > 0) {
      //category search
      let filteredData = this.AllNewsletter.filter(x => x.categoryId == this.selectedCategory$);
      result.push(filteredData);
    }

    if (this.selectedYear$ > 0) {
      //year search

      let filteredData = this.AllNewsletter.filter(x => x.year == this.selectedYear$);

      result.push(filteredData);
    }

    if (result.length > 0) {
      var final = [];

      //combine result into one final array
      result.forEach(function (val, ind, arr) {
        final.push(val);
      });

      //remove duplicates from final array
      var unique = final.filter(function (elem, index, self) {
        return index == self.indexOf(elem);
      });

      this.NewsletterList$ = unique[0];
      this.collectionSize = this.NewsletterList$.length;
    }

    if (this.NewsletterList$.length == 0) {
      this.NewsletterList$ = null;
      this.collectionSize = 0;
    }

  }

  resetSearch() {
    this.selectedCategory$ = 0;
    this.selectedYear$ = 0;
    this.NewsletterList$ = this.AllNewsletter;
    this.collectionSize = this.NewsletterList$.length;
  }

  downloadFile(linkedId: number) {
    var fileInfo = this.newsletterService.getFileInfo(linkedId).subscribe((response) => {

      var fileInfo = response[0];
      console.log(fileInfo)
      fileInfo.fileLocation = this.appConfig.baseUrl + '/Uploads/' + FileSection[fileInfo.fileSection] + '/' + FileType[fileInfo.fileType] + '/' + fileInfo.linkedId + '/' + fileInfo.physicalFileName;

      this.newsletterService.downloadFile(fileInfo.fileLocation).subscribe((fileResponse) => {
        console.log(fileResponse)
        // file-type
        let fileName = fileInfo.displayFileName;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(fileResponse.body);
        if (this.newsletterId > 0)
          window.open(link.href, "_self");
        //}
        else
          window.open(link.href, "_blank");

        //link.download = fileName;
        //link.click();
      }, (error) => {
        console.log(error);
      });

      return fileInfo;
    }, (error) => {
      console.log(error);
    });
  }

}
